import type { ReactNode } from "react";
import { StyleSheet, Text, View } from "react-native";

import {
  radii,
  spacing,
  type,
  useThemedStyles,
  type ThemeColors,
} from "~/styles/theme";

export function Badge({
  children,
  tone = "neutral",
}: {
  children: ReactNode;
  tone?: "neutral" | "mint" | "danger" | "warning" | "success";
}) {
  const { stylesheet, toneStyles } = useThemedStyles(makeStyles);
  return (
    <View style={[stylesheet.badge, toneStyles[tone].wrap]}>
      <Text style={[stylesheet.label, toneStyles[tone].text]}>{children}</Text>
    </View>
  );
}

const makeStyles = (colors: ThemeColors) => {
  const stylesheet = StyleSheet.create({
    badge: {
      alignSelf: "flex-start",
      paddingHorizontal: spacing.s,
      paddingVertical: 3,
      borderRadius: radii.s,
    },
    label: {
      ...type.caption,
      fontFamily: type.label.fontFamily,
    },
    neutralWrap: { backgroundColor: colors.surfaceSunken },
    neutralText: { color: colors.mutedForeground },
    mintWrap: { backgroundColor: colors.successSurface },
    mintText: { color: colors.primary },
    dangerWrap: { backgroundColor: colors.dangerSurface },
    dangerText: { color: colors.danger },
    warningWrap: { backgroundColor: colors.accentSurface },
    warningText: { color: colors.foreground },
    successWrap: { backgroundColor: colors.successSurface },
    successText: { color: colors.primary },
  });
  return {
    stylesheet,
    toneStyles: {
      neutral: { wrap: stylesheet.neutralWrap, text: stylesheet.neutralText },
      mint: { wrap: stylesheet.mintWrap, text: stylesheet.mintText },
      danger: { wrap: stylesheet.dangerWrap, text: stylesheet.dangerText },
      warning: { wrap: stylesheet.warningWrap, text: stylesheet.warningText },
      success: { wrap: stylesheet.successWrap, text: stylesheet.successText },
    },
  };
};
